import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#4edba1', light: '#7de8bd', dark: '#2db87a' },
    secondary: { main: '#f0a856', light: '#f5c078', dark: '#d4893a' },
    error: { main: '#f0656f' },
    background: {
      default: '#0a1628',
      paper: '#111f36',
    },
    text: {
      primary: '#e8edf5',
      secondary: '#8b99b0',
    },
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
    h3: { fontFamily: '"Fraunces", serif', fontWeight: 700, letterSpacing: '-0.02em' },
    h4: { fontFamily: '"Fraunces", serif', fontWeight: 500, letterSpacing: '-0.01em' },
    h5: { fontFamily: '"Fraunces", serif', fontWeight: 500 },
    h6: { fontFamily: '"DM Sans", sans-serif', fontWeight: 600 },
    subtitle1: { fontWeight: 500, color: '#8b99b0' },
    button: { fontWeight: 600, textTransform: 'none', letterSpacing: '0.02em' },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 12, padding: '12px 28px', fontSize: '0.95rem' },
        containedPrimary: {
          background: 'linear-gradient(135deg, #4edba1 0%, #2db87a 100%)',
          boxShadow: '0 4px 20px rgba(78, 219, 161, 0.3)',
          '&:hover': {
            background: 'linear-gradient(135deg, #7de8bd 0%, #4edba1 100%)',
            boxShadow: '0 6px 28px rgba(78, 219, 161, 0.45)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(78, 219, 161, 0.08)',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: '#0a1628',
          backgroundImage: 'none',
        },
      },
    },
  },
});

export default theme;
